// extracted by mini-css-extract-plugin
export default {"TogglePassword":"TogglePassword_TogglePassword__O10x0"};